const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const trimmedEmail = email?.trim();

  if (trimmedEmail && !emailRegex.test(trimmedEmail)) {
    return false;
  }

  return true;
};

export default isValidEmail;
